import React, { Fragment } from "react";
import Message from "assets/scripts/components/common/Message/Message";
const Label = (props) => (<Fragment>
		<Message value={props.label}/>
		{props.required && " *"}
	</Fragment>);
export default Label;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/Label.tsx